export interface StageConfig {
  posUrl: string;
  smartPosUrl: string;
  googleAnalytics: IGoogleAnalytics;
  googleAds: IGoogleAds;
  googleRatingsAndReviews: IGoogleRatingsAndReviews;
  fireworkUrl: string;
  domain: string;
  associationHandle: string;
  returnToUrl: string;
  returnToUrlOnboarding: string
  pageId: string;
  allowCookies: boolean;
  smartbizUrl: string;
  marketingPageUrl: string;
  templateDownload: string;
  storeFrontUrl: string;
  chatScript: string;
  smartBizUrl2: string;
}

interface IGoogleAnalytics {
  GOOGLE_SIGNIN_WEBCLIENT_ID: string;
}

interface IGoogleAds {
  GOOGLE_SIGNIN_WEBCLIENT_ID: string;
}

interface IGoogleRatingsAndReviews {
  GOOGLE_BUSINESS_ACCOUNT_OAUTH_URL: string;
}

interface StageConfigs {
  [key: string]: StageConfig;
}
export interface CurrentStageAndConfig {
  stage: any;
  config: StageConfig;
}

export enum Stages {
  LOCAL = 'local',
  ALPHA = 'alpha',
  BETA = 'beta',
  GAMMA = 'gamma',
  PROD = 'prod',
}

const STAGE_MAPPING: { [key: string]: Stages } = {
  "localhost": Stages.LOCAL,
  'alpha-smartbiz-seller.corp.amazon.com': Stages.ALPHA,
  'beta-smartbiz-seller.corp.amazon.com': Stages.BETA,
  'gamma-smartbiz-seller.corp.amazon.com': Stages.GAMMA,
  'smartbiz.amazon.in': Stages.PROD,
};

const DEFAULT_STAGE = Stages.LOCAL;

interface IgoogleBussinessAccountSignInData {
  [key: string]: {
    GOOGLE_BUSINESS_ACCOUNT_SIGNIN_WEBCLIENT: string;
    REDIRECT_URI: string;
  };
}

//Note: For all environments other than production, use beta-specific Google Business account sign-in configuration.
const googleBussinessAccountSignInData: IgoogleBussinessAccountSignInData = {
  beta: {
    GOOGLE_BUSINESS_ACCOUNT_SIGNIN_WEBCLIENT:
      "371752087480-252cjq8brf3l33vdf4en82nqgkofb72n.apps.googleusercontent.com",
    REDIRECT_URI:
      "https://beta-smartbiz-seller.corp.amazon.com/settings/reviews",
  },
  prod: {
    GOOGLE_BUSINESS_ACCOUNT_SIGNIN_WEBCLIENT:
      "418717149944-cpiaukf96vamcce98q7pdrdadl3h4jti.apps.googleusercontent.com",
    REDIRECT_URI: "https://smartbiz.amazon.in/settings/reviews",
  },
};

const GOOGLE_BUSINESS_ACCOUNT_OAUTH_URL_BETA = `https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?client_id=${googleBussinessAccountSignInData.beta.GOOGLE_BUSINESS_ACCOUNT_SIGNIN_WEBCLIENT}&redirect_uri=${googleBussinessAccountSignInData.beta.REDIRECT_URI}&access_type=offline&prompt=consent&response_type=code&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fbusiness.manage%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fplus.business.manage`;
const GOOGLE_BUSINESS_ACCOUNT_OAUTH_URL_PROD = `https://accounts.google.com/o/oauth2/v2/auth/oauthchooseaccount?client_id=${googleBussinessAccountSignInData.prod.GOOGLE_BUSINESS_ACCOUNT_SIGNIN_WEBCLIENT}&redirect_uri=${googleBussinessAccountSignInData.prod.REDIRECT_URI}&access_type=offline&prompt=consent&response_type=code&scope=https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fbusiness.manage%20https%3A%2F%2Fwww.googleapis.com%2Fauth%2Fplus.business.manage&service=lso&o2v=2&theme=glif&flowName=GeneralOAuthFlow&ddm=1`;

const RangoliStageConfigs: StageConfigs = {
  local: {
    posUrl: 'https://d1y6eovjq6l2o1.cloudfront.net/',
    smartPosUrl: 'https://beta-smartpos-api.corp.amazon.com/',
    fireworkUrl: "https://business.firework.com/integration",
    googleAnalytics: {
      GOOGLE_SIGNIN_WEBCLIENT_ID : '324729287701-28ueb03c9jjtod6bb9e1amgrmem7r0h4.apps.googleusercontent.com',
    },
    googleAds: {
      GOOGLE_SIGNIN_WEBCLIENT_ID : '256090199219-v8os26sjgpksak02dksl0dibjop5kh95.apps.googleusercontent.com'
    },
    googleRatingsAndReviews: {
      GOOGLE_BUSINESS_ACCOUNT_OAUTH_URL : GOOGLE_BUSINESS_ACCOUNT_OAUTH_URL_BETA,
    },
    domain: 'in-development.amazon.com',
    associationHandle: 'amzn_rangoli_seller_in',
    returnToUrl: 'https://localhost.amazon.com:8080/home',
    returnToUrlOnboarding: "https://localhost.amazon.com:3030/store-onboarding",
    pageId: 'amzn_rangoli_seller_in',
    allowCookies: true,
    smartbizUrl: 'https://beta-smartbiz-api.corp.amazon.com',
    marketingPageUrl: 'https://smartcommerce-in.integ.amazon.com/features/test-new',
    templateDownload:
      'https://m.media-amazon.com/images/G/31/CONSTELLATION/Documents/smartbiz_bulk_upload_template_27Feb.xlsx',
    storeFrontUrl: 'https://beta.smartbiz.in/',
    smartBizUrl2: ' https://api-beta.smartbiz.in',
    chatScript:
      'https://static.zdassets.com/ekr/snippet.js?key=e8fc8ae4-c865-4c2e-8bfe-5c626df43f58'
  },
  alpha: {
    posUrl: 'https://d1y6eovjq6l2o1.cloudfront.net/',
    smartPosUrl: 'https://alpha-smartpos-api.corp.amazon.com/',
    fireworkUrl: "https://business.firework.com/integration",
    googleAnalytics: {
      GOOGLE_SIGNIN_WEBCLIENT_ID : '324729287701-28ueb03c9jjtod6bb9e1amgrmem7r0h4.apps.googleusercontent.com',
    },
    googleAds: {
      GOOGLE_SIGNIN_WEBCLIENT_ID : '256090199219-v8os26sjgpksak02dksl0dibjop5kh95.apps.googleusercontent.com'
    },
    googleRatingsAndReviews: {
      GOOGLE_BUSINESS_ACCOUNT_OAUTH_URL : GOOGLE_BUSINESS_ACCOUNT_OAUTH_URL_BETA,
    },
    domain: 'in-development.amazon.com',
    associationHandle: 'amzn_rangoli_seller_in',
    returnToUrl: 'https://alpha-smartbiz-seller.corp.amazon.com/home',
    returnToUrlOnboarding: "https://alpha-smartbiz-seller.corp.amazon.com/store-onboarding",
    pageId: 'amzn_rangoli_seller_in',
    allowCookies: true,
    smartbizUrl: 'https://alpha-smartbiz-api.corp.amazon.com',
    marketingPageUrl: 'https://smartcommerce-in.integ.amazon.com/features/test-new',
    templateDownload:
      'https://m.media-amazon.com/images/G/31/CONSTELLATION/Documents/smartbiz_bulk_upload_template_27Feb.xlsx',
    storeFrontUrl: 'https://alpha.smartbiz.in/',
    chatScript:
      'https://static.zdassets.com/ekr/snippet.js?key=e8fc8ae4-c865-4c2e-8bfe-5c626df43f58',
    smartBizUrl2: ' https://api-alpha.smartbiz.in',
  },
  beta: {
    posUrl: 'https://d1y6eovjq6l2o1.cloudfront.net/',
    smartPosUrl: 'https://beta-smartpos-api.corp.amazon.com/',
    fireworkUrl: "https://business.firework.com/integration",
    googleAnalytics: {
      GOOGLE_SIGNIN_WEBCLIENT_ID : '324729287701-28ueb03c9jjtod6bb9e1amgrmem7r0h4.apps.googleusercontent.com',
    },
    googleAds: {
      GOOGLE_SIGNIN_WEBCLIENT_ID : '256090199219-v8os26sjgpksak02dksl0dibjop5kh95.apps.googleusercontent.com'
    },
    googleRatingsAndReviews: {
      GOOGLE_BUSINESS_ACCOUNT_OAUTH_URL : GOOGLE_BUSINESS_ACCOUNT_OAUTH_URL_BETA,
    },
    domain: 'in-development.amazon.com',
    associationHandle: 'amzn_rangoli_seller_in',
    returnToUrl: 'https://beta-smartbiz-seller.corp.amazon.com/home',
    returnToUrlOnboarding: "https://beta-smartbiz-seller.corp.amazon.com/store-onboarding",
    pageId: 'amzn_rangoli_seller_in',
    allowCookies: true,
    smartbizUrl: 'https://beta-smartbiz-api.corp.amazon.com',
    marketingPageUrl: 'https://smartcommerce-in.integ.amazon.com/features/test-new',
    templateDownload:
      'https://m.media-amazon.com/images/G/31/CONSTELLATION/Documents/smartbiz_bulk_upload_template_27Feb.xlsx',
    storeFrontUrl: 'https://beta.smartbiz.in/',
    chatScript:
      'https://static.zdassets.com/ekr/snippet.js?key=e8fc8ae4-c865-4c2e-8bfe-5c626df43f58',
    smartBizUrl2: ' https://api-beta.smartbiz.in',
  },
  gamma: {
    posUrl: 'https://d2g5xduc8tg3b1.cloudfront.net',
    smartPosUrl: 'https://gamma-smartpos-api.corp.amazon.com/',
    fireworkUrl: "https://business.firework.com/integration",
    googleAnalytics: {
      GOOGLE_SIGNIN_WEBCLIENT_ID : '324729287701-28ueb03c9jjtod6bb9e1amgrmem7r0h4.apps.googleusercontent.com',
    },
    googleAds: {
      GOOGLE_SIGNIN_WEBCLIENT_ID : '256090199219-v8os26sjgpksak02dksl0dibjop5kh95.apps.googleusercontent.com'
    },
    googleRatingsAndReviews: {
      GOOGLE_BUSINESS_ACCOUNT_OAUTH_URL : GOOGLE_BUSINESS_ACCOUNT_OAUTH_URL_BETA,
    },
    domain: 'in-pre-prod.amazon.com',
    associationHandle: 'amzn_rangoli_seller_in',
    returnToUrl: 'https://gamma-smartbiz-seller.corp.amazon.com/home',
    returnToUrlOnboarding: "https://gamma-smartbiz-seller.corp.amazon.com/store-onboarding",
    pageId: 'amzn_rangoli_seller_in',
    allowCookies: true,
    smartbizUrl: 'https://gamma-smartbiz-api.corp.amazon.com',
    smartBizUrl2: ' https://api-gamma.smartbiz.in',
    marketingPageUrl: 'https://smartcommerce-in.integ.amazon.com/features/test-new',
    templateDownload:
      'https://m.media-amazon.com/images/G/31/CONSTELLATION/Documents/smartbiz_bulk_upload_template_27Feb.xlsx',
    storeFrontUrl: 'https://gamma.smartbiz.in/',
    chatScript:
      'https://static.zdassets.com/ekr/snippet.js?key=e8fc8ae4-c865-4c2e-8bfe-5c626df43f58',
  },
  prod: {
    posUrl: 'https://smartpos.amazon.in',
    smartPosUrl: 'https://smartpos.amazon.in/',
    fireworkUrl: "https://business.firework.com/integration",
    googleAnalytics: {
      GOOGLE_SIGNIN_WEBCLIENT_ID : '593845218023-3djnfkfj0redrb30v4mueokb4sfo6rbp.apps.googleusercontent.com',
    },
    googleAds: {
      GOOGLE_SIGNIN_WEBCLIENT_ID : '653779016760-ijoghko1l2mjcbc1f3qp50v40ref16nr.apps.googleusercontent.com'
    },
    googleRatingsAndReviews: {
      GOOGLE_BUSINESS_ACCOUNT_OAUTH_URL : GOOGLE_BUSINESS_ACCOUNT_OAUTH_URL_PROD,
    },
    domain: 'amazon.in',
    associationHandle: 'amzn_rangoli_seller_in',
    returnToUrl: 'https://smartbiz.amazon.in/home',
    returnToUrlOnboarding: "https://smartbiz.amazon.in/store-onboarding",
    pageId: 'amzn_rangoli_seller_in',
    allowCookies: true,
    smartbizUrl: 'https://smartbiz.amazon.in/api',
    smartBizUrl2: ' https://api.smartbiz.in',
    marketingPageUrl: 'https://smartcommerce.amazon.in/smartbiz',
    templateDownload: 'https://m.media-amazon.com/images/G/31/CONSTELLATION/Documents/smartbiz_bulk_upload_template_v3.xls',
    storeFrontUrl: 'https://www.smartbiz.in/',
    chatScript:
      'https://static.zdassets.com/ekr/snippet.js?key=9ec1cec3-c73d-454e-b5f8-2aadb417151e',
  },
};

export const currentHostName = window.location.hostname;
export const currentHost = window.location.host;
export function getCurrentStageAndConfig(): CurrentStageAndConfig {
  const stage = STAGE_MAPPING[currentHostName] || DEFAULT_STAGE;
  const config = RangoliStageConfigs[stage];
  return { stage, config };
}